import {
  faBuilding,
  faCashRegister,
  faClose,
  faCubes,
  faGear,
  faSliders,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@emotion/react";
import { useLocation } from "react-router-dom";
import { IconeBotao } from "../../pages/selecaoEmpresas/styles";
import React, { useEffect, useState } from "react";
import FuncionamentoEmpresa from "../../components/BotaoFuncionamentoEmpresa";
import { useAuth } from "../../contexts/auth";
import { usePermissoesLocalStorage } from "../../utils/usePermissoesLocalStorage";
import { obterStorage } from "../../utils/secureStorage";
import * as S from "./styles";

export function BotaoEngrenagem({ renderTrigger, openSignal }) {
  const [modalEngrenagem, setModalEngrenagem] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const { contratoWaychefAtivo } = useAuth();
  const sessao = obterStorage("sessao");
  const tipoEmpresa = sessao?.empresaDTO?.tipoEmpresa;
  const { verificarPermissao } = usePermissoesLocalStorage();
  const permissaoDownloadAplicativo = verificarPermissao("PARAM_APLIC_DOWNLOAD");
  const permissaoBalancas = verificarPermissao("PARAM_CAD_BALANCA");
  const permissaoCanaisDeVenda = verificarPermissao("PARAM_CAD_CANAIS_VENDA");
  const permissaoEmissoresFiscais = verificarPermissao("PARAM_CAD_EMISSOR_FISCAL");
  const permissaoFormasPagamento = verificarPermissao("PARAM_CAD_FIN_COND_PAG");
  const permissaoImpressoras = verificarPermissao("PARAM_CAD_IMPRESSORA");
  const permissaoPagamento = verificarPermissao("PARAM_CAD_PLANO_PAGAMENTO");
  const permissaoMeusDispositivos = verificarPermissao("PARAM_CAD_ESTACAO");
  const permissaoLayoutConferencia = verificarPermissao("PARAM_LAYOUT_CONF");
  const permissaoModulos = verificarPermissao("CONF_CAD_MODULO");
  const permissaoMinhaEmpresa = verificarPermissao("PESSOA_MINHA_EMPRESA");
  const permissaoUsuario = verificarPermissao("PESSOA_CAD_USUARIO");
  const permissaoPerfil = verificarPermissao("PESSOA_CAD_USUARIO_PERFIL");

  const empresaNaoPlataformaIntegrador =
    tipoEmpresa !== "PLATAFORMA" && tipoEmpresa !== "INTEGRADOR";
  const empresaPlataformaOuIntegrador =
    tipoEmpresa === "PLATAFORMA" || tipoEmpresa === "INTEGRADOR";
  const empresaNaoFranquia = tipoEmpresa !== "FRANQUIA";

  const configuracoesUsuariosItems = [
    permissaoPerfil.consultar && {
      link: "/cadastros/minha-empresa/perfis-usuarios",
      label: "Perfis de usuários",
    },
    permissaoUsuario.consultar && {
      link: "/cadastros/minha-empresa/usuarios",
      label: "Usuários",
    },
  ].filter(Boolean);

  const dadosEmpresaItems = [
    empresaNaoPlataformaIntegrador && {
      link: "/funcionamento-empresa",
      label: "Funcionamento Empresa",
    },

    permissaoMinhaEmpresa.consultar && {
      link: "/dados-empresa",
      label: "Minha Empresa",
    },
    {
      link: "/personalizar-login",
      label: "Personalizar Login",
    },
    empresaNaoPlataformaIntegrador &&
      permissaoPagamento.consultar && {
        link: "/gerenciar-plano",
        label: "Pagamento",
      },

    empresaNaoPlataformaIntegrador &&
      permissaoPagamento.consultar && {
        link: "/transacoes",
        label: "Transações",
      },
    {
      link: "/cadastro-email",
      label: "Cadastro de Email",
    },

    empresaPlataformaOuIntegrador && {
      link: "/modal-informativo/listagem",
      label: "Cadastro de Modal Informativo",
    },
  ].filter(Boolean);

  const parametrosItems = [
    empresaNaoPlataformaIntegrador && {
      link: "/parametros/contingencia-fiscal",
      label: "Contingência Fiscal",
    },

    contratoWaychefAtivo &&
      permissaoCanaisDeVenda.consultar && {
        link: "/parametros/canais-de-venda",
        label: "Canais de venda",
      },

    contratoWaychefAtivo &&
      permissaoBalancas.consultar && {
        link: "/parametros/minhas-balancas/listagem",
        label: "Minhas Balanças",
      },

    contratoWaychefAtivo &&
      permissaoEmissoresFiscais.consultar && {
        link: "/parametros/emissores-fiscais/listagem",
        label: "Emissores Fiscais",
      },

    contratoWaychefAtivo &&
      permissaoDownloadAplicativo.consultar && {
        link: "/parametros/download-de-aplicativos",
        label: "Download de Aplicativos",
      },

    permissaoImpressoras.consultar && {
      link: "/parametros/minhas-impressoras",
      label: "Minhas impressoras",
    },

    empresaNaoFranquia &&
      permissaoMeusDispositivos.consultar && {
        link: "/parametros/meus-dispositivos",
        label: "Meus Dispositivos",
      },
  ].filter(Boolean);

  const caixaItems = [
    permissaoFormasPagamento.consultar && {
      link: "/cadastros/minha-empresa/formas-de-pagamento/listagem",
      label: "Formas de pagamento",
    },

    contratoWaychefAtivo &&
      permissaoLayoutConferencia.consultar && {
        link: "/parametros/caixa/conferencia/listagem",
        label: "Layouts de Conferência",
      },
  ].filter(Boolean);

  const modulosItems = [
    empresaNaoPlataformaIntegrador &&
      permissaoModulos.consultar && {
      link: "/parametros/modulos/habilitar-modulos",
      label: "Habilitar Módulos",
      },
  ].filter(Boolean);

  const deveExibirConfiguracoesUsuarios = configuracoesUsuariosItems.length > 0;
  const deveExibirParametros = parametrosItems.length > 0;
  const deveExibirCaixa = caixaItems.length > 0;
  const deveExibirModulos = modulosItems.length > 0;
  const deveExibirAccordionParametros =
    empresaNaoPlataformaIntegrador && (deveExibirParametros || deveExibirCaixa);

  const renderLinks = (items) =>
    items.map((item) => (
      <React.Fragment key={item.link}>
        <S.LinkStyled to={item.link}>
          <p>{item.label}</p>
        </S.LinkStyled>
        <S.Separador />
      </React.Fragment>
    ));

  function renderModal() {
    return (
      <S.ContainerModal onClick={() => setModalEngrenagem(false)}>
        <S.PainelModal onClick={(e) => e.stopPropagation()}>
          <S.LinhaTitulo>
            <h5>Configurações</h5>

            <IconeBotao onClick={() => setModalEngrenagem(false)}>
              <S.IconeMenu color={theme.cores.textoSimples} icon={faClose} />
            </IconeBotao>
          </S.LinhaTitulo>

          {tipoEmpresa !== "PLATAFORMA" && tipoEmpresa !== "INTEGRADOR" && <FuncionamentoEmpresa />}

          {deveExibirConfiguracoesUsuarios && (
            <S.AccordionStyled>
              <S.AccordionItem
                expandIcon={<ExpandMoreIcon sx={{ color: theme.cores.neutral10 }} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <S.IconeMenu
                  icon={faUserGroup}
                  color={theme.cores.textoSimples}
                  style={{ marginRight: 12 }}
                />
                <S.TypographyTitulo>Configurações de usuários</S.TypographyTitulo>
              </S.AccordionItem>

              <S.AccordionConteudo>{renderLinks(configuracoesUsuariosItems)}</S.AccordionConteudo>
            </S.AccordionStyled>
          )}
          {dadosEmpresaItems.length > 0 && (
            <S.AccordionStyled>
              <S.AccordionItem
                expandIcon={<ExpandMoreIcon sx={{ color: theme.cores.neutral10 }} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <S.IconeMenu
                  icon={faBuilding}
                  color={theme.cores.textoSimples}
                  style={{ marginRight: 12 }}
                />
                <S.TypographyTitulo>Dados da empresa</S.TypographyTitulo>
              </S.AccordionItem>

              <S.AccordionConteudo>{renderLinks(dadosEmpresaItems)}</S.AccordionConteudo>
            </S.AccordionStyled>
          )}

          {deveExibirModulos && (
            <S.AccordionStyled>
              <S.AccordionItem
                expandIcon={<ExpandMoreIcon sx={{ color: theme.cores.neutral10 }} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <S.IconeMenu
                  icon={faCubes}
                  color={theme.cores.textoSimples}
                  style={{ marginRight: 12 }}
                />
                <S.TypographyTitulo>Módulos</S.TypographyTitulo>
              </S.AccordionItem>

              <S.AccordionConteudo>{renderLinks(modulosItems)}</S.AccordionConteudo>
            </S.AccordionStyled>
          )}

          {deveExibirAccordionParametros && (
            <S.AccordionStyled>
              <S.AccordionItem
                expandIcon={<ExpandMoreIcon sx={{ color: theme.cores.neutral10 }} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <S.IconeMenu
                  color={theme.cores.textoSimples}
                  icon={faSliders}
                  style={{ marginRight: 12 }}
                />
                <S.TypographyTitulo> Parâmetros </S.TypographyTitulo>
              </S.AccordionItem>

              <S.AccordionConteudo>
                {renderLinks(parametrosItems)}
                {deveExibirCaixa && (
                  <S.SubTitulo>
                    <S.IconeMenu
                      style={{ marginLeft: 12 }}
                      icon={faCashRegister}
                      color="rgba(28, 27, 31, 1)"
                    />
                    <p>Caixa</p>
                  </S.SubTitulo>
                )}

                {renderLinks(caixaItems)}
              </S.AccordionConteudo>
            </S.AccordionStyled>
          )}
        </S.PainelModal>
      </S.ContainerModal>
    );
  }

  useEffect(() => {
    setModalEngrenagem(false);
  }, [location]);

  useEffect(() => {
    if (openSignal) {
      setModalEngrenagem(true);
    }
  }, [openSignal]);

  const abrirModal = () => setModalEngrenagem(true);

  return (
    <>
      {renderTrigger ? (
        renderTrigger({ onClick: abrirModal })
      ) : (
        <S.IconeMenu style={{ cursor: "pointer" }} icon={faGear} onClick={abrirModal} />
      )}
      {modalEngrenagem && renderModal()}
    </>
  );
}

export default BotaoEngrenagem;
